import PropTypes from 'prop-types';
import { Fragment } from 'react';

import withTheme from 'core/hocs/withTheme';
import Link from 'core/components/Link';
import { resolveScopedStyles } from 'core/utils/styled-jsx';
import themePropTypes from 'core/utils/prop-types/theme';

function Source(props) {
  const {
    sourceUrl,
    title,
    children,
    theme: {
      animations: {
        hover: hoverAnimation,
      },
      controls: {
        topicFooter: {
          links: linksAtoms,
        },
      },
    },
  } = props;

  const scoped = resolveScopedStyles(
    <scope>
      <style jsx>{`
        .link
          border-bottom ${linksAtoms.borderBottom}
          transition border-color ${hoverAnimation}
          &:hover
            border-bottom ${linksAtoms.hover.borderBottom}
        .linkTitle
          font ${linksAtoms.title.font}
          color ${linksAtoms.title.color}
        .link
        .text
          font ${linksAtoms.font}
          margin-left ${linksAtoms.marginLeft}
          color ${linksAtoms.color}
      `}</style>
    </scope>
  );

  const Wrapper = sourceUrl ? Link : 'span';
  const wrapperProps = sourceUrl ? { to: sourceUrl, type: linksAtoms.type } : {};
  return (
    <Fragment>
      <span className={scoped.wrapClassNames('linkTitle')}>
        {title}
      </span>
      <Wrapper
        className={scoped.wrapClassNames(sourceUrl ? 'link' : 'text')}
        {...wrapperProps}
      >
        {children}
      </Wrapper>
      <scoped.styles />
    </Fragment>
  );
}

Source.propTypes = {
  theme: themePropTypes(`{
    animations: {
      hover,
    },
    controls: {
      topicFooter: {
        links: {
          marginLeft,
          borderBottom,
          type,
          hover: {
            borderBottom,
          }
        },
      }
    }
  }`),
  sourceUrl: PropTypes.string,
  title: PropTypes.string.isRequired,
};

export default withTheme(Source);
